import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { FadeUp, Overline } from "@/components/FadeUp";
import ModelCard from "@/components/ModelCard";

export default function Models() {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    api.get("/models")
      .then((r) => setModels(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="models-page">
      <section className="py-20 md:py-28 border-b border-slate-200 bg-[#F4F7F9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Overline>{t("modelsPage.overline")}</Overline>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-[#0A2540] max-w-2xl">
            {t("modelsPage.title")}
          </h1>
          <p className="mt-5 text-base md:text-lg text-slate-600 max-w-xl leading-relaxed">
            {t("modelsPage.subtitle")}
          </p>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {loading ? (
            <p className="text-slate-500" data-testid="models-loading">{t("modelsPage.loading")}</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="models-grid">
              {models.map((m, i) => (
                <FadeUp key={m.slug} delay={(i % 2) * 0.1}>
                  <ModelCard model={m} large />
                </FadeUp>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
